/**
 * CanvasLineRow — `canvas.line` renderer. Connects the parent
 * `(number, series)` source's points into a polyline.
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/** The `canvas.line` painter row: joins its parent series source's points into a polyline. */
export class CanvasLineRow extends RendererRow {
  get seriesKey(): string {
    return Json.string(this.attrs(), "key") ?? "default";
  }

  get color(): Option<string> {
    return Json.string(this.attrs(), "color");
  }

  get strokeWidth(): number {
    return Json.number(this.attrs(), "strokeWidth") ?? 1;
  }
}
